import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Alert, AlertDescription } from '../ui/alert';
import { CheckCircle, CreditCard, Building2, Info, Loader2 } from 'lucide-react';

export default function ResultatFTPE({ savedSimulation, identite, confirmingFTPE, handleConfirmFTPEPayment }) {
  if (identite.qualite === 'particulier') return null;

  return (
    <Card className="border-2 border-teal-200 bg-teal-50/30" data-testid="ftpe-virement-instructions">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2 text-teal-700">
          <Building2 className="h-5 w-5" />
          Instructions de paiement - Adhesion FTPE
        </CardTitle>
        <p className="text-sm text-gray-600">
          Le paiement de l'adhesion FTPE s'effectue par virement bancaire aux coordonnees ci-dessous.
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="bg-white p-4 rounded-lg border border-teal-100 space-y-3">
          <div className="flex justify-between items-center pb-3 border-b border-teal-100">
            <span className="text-sm text-gray-600 font-medium">Montant a virer :</span>
            <span className="text-lg font-bold text-teal-800">200,00 EUR</span>
          </div>
          <div className="flex justify-between items-center pb-3 border-b border-teal-100">
            <span className="text-sm text-gray-600 font-medium">Reference de virement :</span>
            <span className="font-mono font-bold text-teal-800">FTPE-{savedSimulation.reference || (identite.nom || '').toUpperCase()}</span>
          </div>
          <div className="text-xs font-semibold text-teal-600 uppercase mb-1">RIB FTPE</div>
          <div className="flex items-center gap-2 mb-1">
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-teal-100 text-teal-800 text-xs font-semibold">
              <CreditCard className="h-3.5 w-3.5" />
              BRED Banque Populaire
            </div>
          </div>
          <div className="grid grid-cols-1 gap-2 text-sm">
            <div><span className="text-gray-500 font-medium">Titulaire :</span> <span className="font-semibold text-gray-900">FEDERATION DES TRES PETITES ENTREPRISES</span></div>
            <div><span className="text-gray-500 font-medium">Banque :</span> <span className="text-gray-900">BRED Banque Populaire - BRED BAIE MAHAULT JARRY</span></div>
            <div>
              <span className="text-gray-500 font-medium">IBAN :</span>{' '}
              <span className="font-mono font-bold text-teal-800 bg-teal-50 px-2 py-0.5 rounded text-base tracking-wide">FR76 1010 7004 7300 6370 6380 902</span>
            </div>
            <div><span className="text-gray-500 font-medium">BIC / SWIFT :</span> <span className="font-mono font-semibold text-gray-900">BREDFRPPXXX</span></div>
            <div><span className="text-gray-500 font-medium">Adresse agence :</span> <span className="text-gray-900">387 Rue de l'Industrie, Z.I de Jarry, 97122 Baie-Mahault</span></div>
          </div>
        </div>

        <Alert className="border-teal-200 bg-teal-100/50">
          <Info className="h-4 w-4 text-teal-600" />
          <AlertDescription className="text-teal-800 text-sm">
            Merci d'indiquer la reference <strong className="font-mono">FTPE-{savedSimulation.reference || (identite.nom || '').toUpperCase()}</strong> dans le libelle de votre virement pour faciliter le rapprochement bancaire.
          </AlertDescription>
        </Alert>

        {/* Bouton Proceder au paiement FTPE */}
        {!savedSimulation.ftpe_paiement_valide && (
          <div className="pt-2">
            <Button
              onClick={() => handleConfirmFTPEPayment(savedSimulation.reference)}
              disabled={confirmingFTPE}
              className="w-full bg-gradient-to-r from-teal-600 to-emerald-600 hover:from-teal-700 hover:to-emerald-700 text-white font-semibold py-3 shadow-lg h-12"
              data-testid="btn-ftpe-payment"
            >
              {confirmingFTPE ? (
                <><Loader2 className="h-5 w-5 mr-2 animate-spin" />Traitement en cours...</>
              ) : (
                <><CreditCard className="h-5 w-5 mr-2" />Proceder au paiement</>
              )}
            </Button>
            <p className="text-center mt-2" style={{ fontSize: '9px' }}>
              Cliquez une fois le virement bancaire realise pour generer votre recu de contribution solidaire ESS
            </p>
          </div>
        )}

        {/* Confirmation FTPE paiement */}
        {savedSimulation.ftpe_paiement_valide && (
          <div className="pt-2 bg-green-50 -mx-4 -mb-4 p-4 rounded-b-lg border-t border-green-200">
            <div className="flex items-center gap-3 text-green-700">
              <CheckCircle className="h-6 w-6" />
              <div>
                <p className="font-bold">Paiement FTPE confirme</p>
                <p className="text-sm text-green-600">Recu et attestation FTPE signes generes</p>
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
